// Create Ticket
import axios from 'axios';
const uuidv4 = require('uuid/v4');
export default({
    data(){
        return {
            // isUploadingInProgress: false,
            // attachment_file:"",
            // download_url:"",
            // check_attachments: false,
            // input_file:[],
            // input_file_inside:[],
        }
    },
    methods: {
        /**************************************
         ******** Helpdesk Attachments ********
         **************************************/
         dragOverAttachment(evt) {
            // Prevent default behavior (Prevent file from being opened)
            evt.preventDefault();
        },
        dropDefaultAttachment(evt) {
            evt.preventDefault();
            [...evt.dataTransfer.files].forEach((file, i) => {
                    this.uploadDefaultFromDrop(file)
            });
        },
        async getCameraSelection() {
            const devices = await navigator.mediaDevices.enumerateDevices();
            const videoDevices = devices.filter(device => device.kind === 'videoinput');
            this.camera_selection = videoDevices;
            this.selected_camera_device = videoDevices[0].deviceId;
        },
        uploadDefaultFromDrop(event){
            let contains_duplicates = false
            this.attachments.forEach((e) => {
                if(e.name == event.name){
                    contains_duplicates = true
                }
            })
            if(this.attachments.length < 10 && !contains_duplicates){
                if(event) {
                    var input = event;
                }
                if (input && event) {
                    const CancelToken = axios.CancelToken;
                    const source = CancelToken.source();
                    let attachment = {
                        name: input.name,
                        size: JSON.stringify(input.size),
                        source: source,
                        progress: 0,
                        created_time: new Date(),
                        error: ""
                    }
                    this.attachments.push(attachment);
                    this.getResumable(input, this.attachments[this.attachments.length - 1]);
                } 
            } else if(contains_duplicates){
                this.$toasted.global.error("This file is already uploaded")
            } else {
                this.$toasted.global.error("you're not allowed to upload more than 10 Attachments")
            }  
        },
        uploadAttachmentFromCamera(file_data){
            let contains_duplicates = false
            this.attachments.forEach((e) => {
                if(e.name == file_data.name){
                    contains_duplicates = true
                }
            })
            if(this.attachments.length < 10 && !contains_duplicates){
                if (file_data) {
                    const CancelToken = axios.CancelToken;
                    const source = CancelToken.source();
                    let attachment = {
                        name: file_data.name,
                        size: JSON.stringify(file_data.size),
                        source: source,
                        progress: 0,
                        created_time: new Date(),
                        error: ""
                    }
                    this.attachments.push(attachment)
                    this.getResumable(file_data, this.attachments[this.attachments.length - 1]);
                }
            } else if(contains_duplicates){
                this.$toasted.global.error("This file is already uploaded")
            } else {
                this.$toasted.global.error("you're not allowed to upload more than 10 Attachments")
            }
        },
        async downloadImageByPart(index){
            const canvas = document.getElementById('photoTaken').toDataURL("image/png")
            const base64 = await fetch(canvas);
            const blob = await base64.blob();
            let fill = this.blobToFile(blob, 'captured_image' + (new Date().getHours()  + '' + new Date().getMinutes()  + '' + new Date().getSeconds()) +'.png');
            this.uploadAttachmentFromCameraByPart({fill, index});
            this.show_capture_image_multi = false;
            this.$modal.hide(`capture-image${index}`);
            this.toggleCameraMultiPart(index)
            this.stopCameraStreamMultiPart(index);
        },
        async downloadImage() {
            const canvas = document.getElementById("photoTaken").toDataURL("image/png")
            const base64 = await fetch(canvas);
            const blob = await base64.blob();
            let fill = this.blobToFile(blob, 'captured_image' + (new Date().getHours()  + '' + new Date().getMinutes()  + '' + new Date().getSeconds()) +'.png');
            this.uploadAttachmentFromCamera(fill);
            this.show_capture_image = false;
            this.$modal.hide('capture-image');
            this.toggleCamera()
            this.stopCameraStream();
        },
        dropAttachment(evt, index) {
            // Prevent default behavior (Prevent file from being opened)
            evt.preventDefault();
            // Use DataTransfer interface to access the file(s)
            [...evt.dataTransfer.files].forEach((file, i) => {
                this.uploadFromDrop(file, index)
            });
        },
        dropAttachmentDefaultFieldAttachment(evt, field_index) {
            evt.preventDefault();
            if(this.template_details[field_index].attachments.length + [...evt.dataTransfer.files].length <= 5){
                [...evt.dataTransfer.files].forEach((file, i) => {
                    this.uploadFromDropDefaultFieldAttachment(file, field_index)
                });
            } else {
                this.$toasted.global.error("Attachments limit should not exceed more than 5")
            }
        },
        dropAttachmentMPFieldAttachment(evt, part_index, field_index) {
            evt.preventDefault();
            if(this.template_details[part_index].parts_data[field_index].attachments.length + [...evt.dataTransfer.files].length <= 5){
                [...evt.dataTransfer.files].forEach((file, i) => {
                    this.uploadFromDropMPFieldAttachment(file, part_index, field_index)
                });
            } else {
                this.$toasted.global.error("Attachments limit should not exceed more than 5")
            }
        },
        uploadFromDropMPFieldAttachment(event, part_index, field_index) {
            let contains_duplicates = false
            this.template_details[part_index].parts_data[field_index].attachments.forEach((e) => {
                if(e.name == event.name){
                    contains_duplicates = true
                }
            })
            if(!contains_duplicates){
                if(event) {
                    var input = event;
                }
                if (input && event) {
                    const CancelToken = axios.CancelToken;
                    const source = CancelToken.source();
                    let attachment = {
                        name: input.name,
                        size: JSON.stringify(input.size),
                        source: source,
                        progress: 0,
                        created_time: new Date(),
                        error: ""
                    }
                    this.template_details[part_index].parts_data[field_index].attachments.push(attachment)
                    this.template_details[part_index].parts_data[field_index].attachment_error = false 
                    this.getResumable(input, this.template_details[part_index].parts_data[field_index].attachments[this.template_details[part_index].parts_data[field_index].attachments.length - 1]);
                }
            } else {
                this.$toasted.global.error("This file is already uploaded")
            }
        },
        uploadFromDropDefaultFieldAttachment(event, field_index) {
            let contains_duplicates = false
            this.template_details[field_index].attachments.forEach((e) => {
                if(e.name == event.name){
                    contains_duplicates = true
                }
            })
            if(!contains_duplicates){
                if(event) {
                    var input = event;
                }
                if (input && event) {
                    const CancelToken = axios.CancelToken;
                    const source = CancelToken.source();
                    let attachment = {
                        name: input.name,
                        size: JSON.stringify(input.size),
                        source: source,
                        progress: 0,
                        created_time: new Date(),
                        error: ""
                    }
                    this.template_details[field_index].attachments.push(attachment) 
                    this.template_details[field_index].attachment_error = false 
                    this.getResumable(input, this.template_details[field_index].attachments[this.template_details[field_index].attachments.length - 1]);
                }
            } else {
                this.$toasted.global.error("This file is already uploaded")
            }
        },
        uploadDefaultFieldAttachment(event, index){
            console.log('uploadDefaultFieldAttachment')
            if(event) {
                var input = event.file;
            }
            let contains_duplicates = false
            this.template_details[index].attachments.forEach((e) => {
                if(e.name == input.name){
                    contains_duplicates = true
                }
            })
            if(!contains_duplicates){
                if (input) {
                    const CancelToken = axios.CancelToken;
                    const source = CancelToken.source();
                    let attachment = {
                        name: input.name,
                        size: JSON.stringify(input.size),
                        source: source,
                        progress: 0,
                        created_time: new Date(),
                        error: ""
                    }
                    this.template_details[index].attachments.push(attachment) 
                    this.template_details[index].attachment_error = false 
                    this.getResumable(input, this.template_details[index].attachments[this.template_details[index].attachments.length - 1]);
                }
            } else {
                this.$toasted.global.error("This file is already uploaded")
            }
        },
        uploadMPFieldAttachment(event, part_index, field_index){
            console.log('uploadMPFieldAttachment')
            if(event) {
                var input = event.file;
            }
            let contains_duplicates = false
            this.template_details[part_index].parts_data[field_index].attachments.forEach((e) => {
                if(e.name == input.name){
                    contains_duplicates = true
                }
            })
            if(!contains_duplicates){
                if (input && event) {
                    const CancelToken = axios.CancelToken;
                    const source = CancelToken.source();
                    let attachment = {
                        name: input.name,
                        size: JSON.stringify(input.size),
                        source: source,
                        progress: 0,
                        created_time: new Date(),
                        error: ""
                    }
                    this.template_details[part_index].parts_data[field_index].attachments.push(attachment) 
                    this.template_details[part_index].parts_data[field_index].attachment_error = false 
                    this.getResumable(input, this.template_details[part_index].parts_data[field_index].attachments[this.template_details[part_index].parts_data[field_index].attachments.length - 1]);
                }
            } else {
                this.$toasted.global.error("This file is already uploaded")
            }
        },

        /**************************************
         ******** Common Attachments ********
         **************************************/
         uploadFromEmailAttachment(event) {
            const total_allowed_size = 25600 // 25MB
            let total_size_occupied = this.attachments.reduce((a, b) => a + parseInt(b.size), 0)
            if(event) {
                var input = event.file;
            }
            if(total_allowed_size > parseInt((input.size * 0.001).toFixed(3)) && total_allowed_size > total_size_occupied){
                let contains_duplicates = false
                this.attachments.forEach((e) => {
                    if(e.name == event.name){
                        contains_duplicates = true
                    }
                })
                if(!contains_duplicates){
                    if (input && event) {
                        const CancelToken = axios.CancelToken;
                        const source = CancelToken.source();
                        let attachment = {
                            name: input.name,
                            size: JSON.stringify(input.size),
                            source: source,
                            progress: 0,
                            created_time: new Date(),
                            error: ""
                        }
                        this.attachments.push(attachment) 
                        this.getResumable(input, this.attachments[this.attachments.length - 1]);
                    }
                } else {
                    this.$toasted.global.error("This file is already uploaded")
                }
            } else {
                this.$toasted.global.error("Total File sizes must be less than 25MB")
            }
        },
        uploadAttachmentsData(newFile) {
            console.log('uploadAttachmentsData')
            let contains_duplicates = false
            this.attachments.forEach((e) => {
                if(e.name == newFile.name){
                    contains_duplicates = true
                }
            })
            if(this.attachments.length < 10 && !contains_duplicates){
                var input = newFile;
                this.total_file_size = this.total_file_size + input.file.size
                if (input.file) {
                    const CancelToken = axios.CancelToken;
                    const source = CancelToken.source();
                    let attachment = {
                        name: input.file.name,
                        size: JSON.stringify(input.file.size),
                        source: source,
                        progress: 0,
                        created_time: new Date(),
                        error: ""
                    }
                    this.attachments.push(attachment);
                    this.getResumable(input.file, this.attachments[this.attachments.length - 1]);
                }
            } else if(contains_duplicates){
                this.$toasted.global.error("This file is already uploaded")
            } else {
                this.$toasted.global.error("you're not allowed to upload more than 10 Attachments")
            }
        },
        uploadFromDrop(event, index) {
            let contains_duplicates = false
            this.template_details[index].attach_files.forEach((e) => {
                if(e.name == event.name){
                    contains_duplicates = true
                }
            })
            if(this.template_details[index].attach_files.length < 10 && !contains_duplicates){
                if(event) {
                    var input = event;
                }
                if (input && event) {
                    const CancelToken = axios.CancelToken;
                    const source = CancelToken.source();
                    let attachment = {
                        //id: uuidv4(),
                        name: input.name,
                        size: JSON.stringify(input.size),
                        source: source,
                        progress: 0,
                        created_time: new Date(),
                        error: ""
                    }
                    if(this.template_details[index].attach_files.length < 10){
                        this.template_details[index].attach_files.push(attachment)
                        this.getResumable(input, this.template_details[index].attach_files[this.template_details[index].attach_files.length - 1]);
                    } else {
                        this.$toasted.global.error("you're not allowed to upload more than 10 Attachments")
                    }
                }
            } else if(contains_duplicates){
                this.$toasted.global.error("This file is already uploaded")
            } else {
                this.$toasted.global.error("you're not allowed to upload more than 10 Attachments")
            }
        },
        //Upload attachment to cloud and creates URL
        getResumable(file, attachment) {
            this.isUploadingInProgress = true;
            attachment.uploading = true;
            let data = {
                file: attachment.name
            }
            let usage_type = {
                usage: "attachment"
            }
            data = new FormData()
            data.append('file', file)
            Object.keys(usage_type).map(e => {
                data.append(e, JSON.stringify(usage_type[e]))
            })
            this.$http.post('https://cloudapis.digicollect.com/external/upload_file', data, {
                onUploadProgress: function (progressEvent) {
                    let progress = parseInt(Math.round((progressEvent.loaded * 100) / progressEvent
                        .total));
                    if (progress < 100) {
                        attachment.progress = progress;
                    }
                }.bind(this)
            })
            .then(response => {
                let resumable_url = response.data.url;
                attachment.url = resumable_url;
                attachment.progress = 100;
                attachment.uploading = false;
                this.isUploadingInProgress = false;
                delete attachment['source'];
            })
            .catch(error => {
                // console.log(error.data.reason)
            })
        },
        uploadAttachment(newFile, oldFile) {
            console.log('uploadAttachment')
            const total_allowed_size = 25600 // 25MB
            let contains_duplicates = false
            this.attachments.forEach((e) => {
                if(e.name == newFile.name){
                    contains_duplicates = true
                }
            })
            if(this.attachments.length < 10 && !contains_duplicates){
                var input = newFile;
                this.total_file_size = this.total_file_size + input.file.size
                if (input.file) {
                    const CancelToken = axios.CancelToken;
                    const source = CancelToken.source();
                    let attachment = {
                        name: input.file.name,
                        size: JSON.stringify(input.file.size),
                        source: source,
                        progress: 0,
                        created_time: new Date(),
                        error: ""
                    }
                    this.attachments.push(attachment);
                    this.getResumable(input.file, this.attachments[this.attachments.length - 1]);
                }
            } else if(contains_duplicates){
                this.$toasted.global.error("This file is already uploaded")
            } else {
                this.$toasted.global.error("you're not allowed to upload more than 10 Attachments")
            }
        },
        blobToFile(theBlob, fileName){
            //A Blob() is almost a File() - it's just missing the two properties below which we will add
            theBlob.lastModifiedDate = new Date();
            theBlob.name = fileName;
            const myFile = new File([theBlob], 'captured_image' + (new Date().getHours()  + '' + new Date().getMinutes()  + '' + new Date().getSeconds()) +'.png', {
                type: theBlob.type,
            });
            return myFile;
        },
        takePhoto() {
            if(!this.isPhotoTaken) {
                this.isShotPhoto = true;
                const FLASH_TIMEOUT = 50;
                setTimeout(() => {
                this.isShotPhoto = false;
                }, FLASH_TIMEOUT);
            }
            this.isPhotoTaken = !this.isPhotoTaken;
            const context = this.$refs.canvas.getContext('2d');
            context.drawImage(this.$refs.camera_capture, 0, 0, 250, 250);
        },
        takePhotoMultiPart(field_index) {
            if(!this.isPhotoTaken) {
                this.isShotPhoto = true;
                const FLASH_TIMEOUT = 50;
                setTimeout(() => {
                this.isShotPhoto = false;
                }, FLASH_TIMEOUT);
            }
            this.isPhotoTaken = !this.isPhotoTaken;
            const context = this.$refs.canvas[field_index].getContext('2d');
            context.drawImage(this.$refs.camera_capture[field_index], 0, 0, 250, 250);
        },
        toggleCamera() {
            if(this.isCameraOpen) {
                this.stopCameraStream();
                this.isCameraOpen = false;
                this.isPhotoTaken = false;
                this.isShotPhoto = false;
            } else {
                this.isCameraOpen = true;
                this.createCameraElement();
            }
        },
        toggleCameraMultiPart(field_index) {
            if(this.isCameraOpen) {
                this.stopCameraStreamMultiPart(field_index);
                this.isCameraOpen = false;
                this.isPhotoTaken = false;
                this.isShotPhoto = false;
            } else {
                this.isCameraOpen = true;
                this.createCameraElementMultiPart(field_index);
            }
        },
        createCameraElement() {
            this.isLoading = true;
            const constraints = (window.constraints = {
                audio: false,
                video: true
            });
            navigator.mediaDevices
                .getUserMedia(constraints)
                .then(stream => {
                this.isLoading = false;
                this.$refs.camera_capture.srcObject = stream;
                this.isCameraOpen = true
            })
            .catch(error => {
                console.log(error)
                this.isLoading = false;
                this.show_capture_image = false;
                setTimeout(() => {
                    this.$modal.hide('capture-image');
                }, 500);
                alert("Please allow the camera access or your browser may not support it.");
            });
        },
        createCameraElementMultiPart(field_index) {
            this.isLoading = true;
            const constraints = (window.constraints = {
                audio: false,
                video: true
            });
            setTimeout(() => {
                navigator.mediaDevices
                    .getUserMedia(constraints)
                    .then(stream => {
                        this.isLoading = false;
                        console.log(this.$refs["camera_capture"+field_index][0])
                        this.$refs["camera_capture"+field_index][0].srcObject = stream;
                    })
                    this.isCameraOpen = true
                .catch(error => {
                    this.isLoading = false;
                    this.show_capture_image_multi = false;
                    setTimeout(() => {
                        this.$modal.hide(`capture-image${field_index}`);
                    }, 500);
                    alert("Please allow the camera access or your browser may not support it.");
                });
            }, 2000);
        },
        stopCameraStream() {
            let tracks = this.$refs.camera_capture.srcObject.getTracks();
            tracks.forEach(track => {
                track.stop();
            });
            this.show_capture_image = false;
            setTimeout(() => {
                this.$modal.hide('capture-image');
                this.stopCameraStream();
            }, 500);
        },
        stopCameraStreamMultiPart(field_index) {
            console.log(this.$refs['camera_capture'+field_index][0])
            let tracks = this.$refs['camera_capture'+field_index][0].srcObject.getTracks();
            tracks.forEach(track => {
                track.stop();
            });
            this.show_capture_image_multi = false;
            setTimeout(() => {
                this.$modal.hide(`capture-image${field_index}`);
                this.stopCameraStreamMultiPart(field_index);
            }, 500);
        },
        hideView() {
            this.toggleCamera();
        },
        hideViewMultiPart(index){
            this.toggleCameraMultiPart(index)
        },
        openCaptureImage() {
            this.isCameraOpen = false
            this.isPhotoTaken = false
            if(this.attachments.length < 10){
                if ('mediaDevices' in navigator && 'getUserMedia' in navigator.mediaDevices) {
                    this.show_capture_image = true;
                    setTimeout(() => {
                        this.$modal.show('capture-image');
                        this.getCameraSelection()
                        this.toggleCamera();
                    }, 500);
                }
                else {
                    this.warning_msg = "Camera capture device not found";
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 3000);
                }
            } else {
                this.$toasted.global.error("you're not allowed to upload more than 10 Attachments")
            }
        },
        openCaptureImageMulti(field_index) {
            this.isCameraOpen = false
            if(this.template_details[field_index].attach_files.length < 10){
                if ('mediaDevices' in navigator && 'getUserMedia' in navigator.mediaDevices) {
                    this.show_capture_image_multi = true;
                    setTimeout(() => {
                        this.$modal.show(`capture-image${field_index}`);
                        this.getCameraSelection()
                        this.toggleCameraMultiPart(field_index);
                    }, 500);
                }
                else {
                    this.warning_msg = "Camera capture device not found";
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 3000);
                }
            } else {
                this.$toasted.global.error("you're not allowed to upload more than 10 Attachments")
            }
        },
        deleteAttachment(attachment,index){
            this.attachments.forEach((el,elindex)=>{
                if(el.url == attachment.url){
                    this.attachments.splice(elindex,1)
                }
            })
        },
        deleteAttachmentByPart(attachment,part_index){
            this.template_details[part_index].attach_files.forEach((el,elindex)=>{
                if(el.url == attachment.url){
                    this.template_details[part_index].attach_files.splice(elindex,1)
                }
            })
            this.$forceUpdate()
        },
        deleteMPFieldAttachment(part_index, field_index, attachment_index){
            this.template_details[part_index].parts_data[field_index].attachments.splice(attachment_index, 1)
            this.$forceUpdate()
        },
        deleteDefaultFieldAttachment(index, attachment_index){
            this.template_details[index].attachments.splice(attachment_index, 1)
            this.$forceUpdate()
        },
        handlePasteMultiPart(event, field_index, index) {
            // Access clipboard data
            const clipboardData = event.clipboardData || window.clipboardData;
            if(this.isUploadingInProgress) {
                this.$toasted.global.error("Please wait. Previous file upload already in progress")
            } else {
                if (clipboardData) {
                    const items = clipboardData.items;

                    for (let i = 0; i < items.length; i++) {
                        const item = items[i];
                        // Check if the item is an image
                        if (item.type.indexOf('image') !== -1) {
                            const blob = item.getAsFile();

                            // Convert the blob to data URL
                            const reader = new FileReader();
                            reader.readAsDataURL(blob);
                            reader.onload = (e) => {
                            this.cropSuccessMultiPart(e.target.result, field_index, index)
                            };
                        }
                    }
                }
            }
        },
        handlePasteByPart(event, field_index) {
            // Access clipboard data
            const clipboardData = event.clipboardData || window.clipboardData;
            if(this.isUploadingInProgress) {
                this.$toasted.global.error("Please wait. Previous file upload already in progress")
            } else {
                if (clipboardData) {
                    const items = clipboardData.items;

                    for (let i = 0; i < items.length; i++) {
                        const item = items[i];
                        // Check if the item is an image
                        if (item.type.indexOf('image') !== -1) {
                            const blob = item.getAsFile();

                            // Convert the blob to data URL
                            const reader = new FileReader();
                            reader.readAsDataURL(blob);
                            reader.onload = (e) => {
                            this.cropSuccessByPart(e.target.result, field_index)
                            };
                        }
                    }
                }
            }
        },
        handlePasteDefaultField(event, index) {
            // Access clipboard data
            const clipboardData = event.clipboardData || window.clipboardData;
            if(this.isUploadingInProgress) {
                this.$toasted.global.error("Please wait. Previous file upload already in progress")
            } else {
                if (clipboardData) {
                    const items = clipboardData.items;

                    for (let i = 0; i < items.length; i++) {
                        const item = items[i];
                        // Check if the item is an image
                        if (item.type.indexOf('image') !== -1) {
                            const blob = item.getAsFile();

                            // Convert the blob to data URL
                            const reader = new FileReader();
                            reader.readAsDataURL(blob);
                            reader.onload = (e) => {
                            this.cropSuccessDefaultField(e.target.result, index)
                            };
                        }
                    }
                }
            }
        },
        handlePasteDefaultAttachment(event) {
            // Access clipboard data
            const clipboardData = event.clipboardData || window.clipboardData;
            if(this.isUploadingInProgress) {
                this.$toasted.global.error("Please wait. Previous file upload already in progress")
            } else {
                if (clipboardData) {
                    const items = clipboardData.items;

                    for (let i = 0; i < items.length; i++) {
                        const item = items[i];
                        // Check if the item is an image
                        if (item.type.indexOf('image') !== -1) {
                            const blob = item.getAsFile();

                            // Convert the blob to data URL
                            const reader = new FileReader();
                            reader.readAsDataURL(blob);
                            reader.onload = (e) => {
                            this.cropSuccessDefaultAttachment(e.target.result)
                            };
                        }
                    }
                }
            }
        },
        blobToFileClipboard(theBlob, fileName){
            //A Blob() is almost a File() - it's just missing the two properties below which we will add
            theBlob.lastModifiedDate = new Date();
            theBlob.name = fileName;
            const myFile = new File([theBlob], 'clipboard_copied_image' + (new Date().getHours()  + '' + new Date().getMinutes()  + '' + new Date().getSeconds()) +'.png', {
                type: theBlob.type,
            });
            return myFile;
        },
        async cropSuccessMultiPart(imgData, part_index, field_index) {
            const base64 = await fetch(imgData);
            const blob = await base64.blob();
            let file_data = this.blobToFileClipboard(blob, 'clipboard_copied_image' + (new Date().getHours()  + '' + new Date().getMinutes()  + '' + new Date().getSeconds()) +'.png');
            // file_data  // file format type data of image
            // this.uploadMPFieldAttachment(file_data, field_index, i)
            let contains_duplicates = false
            this.template_details[part_index].parts_data[field_index].attachments.forEach((e) => {
                if(e.name == file_data.name){
                    contains_duplicates = true
                }
            })
            if(this.template_details[part_index].parts_data[field_index].attachments.length < 10 && !contains_duplicates){
                if (file_data) {
                    const CancelToken = axios.CancelToken;
                    const source = CancelToken.source();
                    let attachment = {
                        name: file_data.name,
                        size: JSON.stringify(file_data.size),
                        source: source,
                        progress: 0,
                        created_time: new Date(),
                        error: ""
                    }
                    this.template_details[part_index].parts_data[field_index].attachments.push(attachment)
                    this.getResumable(file_data, this.template_details[part_index].parts_data[field_index].attachments[this.template_details[part_index].parts_data[field_index].attachments.length - 1]);
                }
            } else if(contains_duplicates){
                this.$toasted.global.error("This file is already uploaded")
            } else {
                this.$toasted.global.error("you're not allowed to upload more than 10 Attachments")
            }
        },
        async cropSuccessByPart(imgData, index) {
            const base64 = await fetch(imgData);
            const blob = await base64.blob();
            let file_data = this.blobToFileClipboard(blob, 'clipboard_copied_image' + (new Date().getHours()  + '' + new Date().getMinutes()  + '' + new Date().getSeconds()) +'.png');
            let contains_duplicates = false
            this.template_details[index].attach_files.forEach((e) => {
                if(e.name == file_data.name){
                    contains_duplicates = true
                }
            })
            if(this.template_details[index].attach_files.length < 10 && !contains_duplicates){
                if (file_data) {
                    const CancelToken = axios.CancelToken;
                    const source = CancelToken.source();
                    let attachment = {
                        name: file_data.name,
                        size: JSON.stringify(file_data.size),
                        source: source,
                        progress: 0,
                        created_time: new Date(),
                        error: ""
                    }
                    this.template_details[index].attach_files.push(attachment)
                    this.getResumable(file_data, this.template_details[index].attach_files[this.template_details[index].attach_files.length - 1]);
                }
            } else if(contains_duplicates){
                this.$toasted.global.error("This file is already uploaded")
            } else {
                this.$toasted.global.error("you're not allowed to upload more than 10 Attachments")
            }
        },
        async cropSuccessDefaultField(imgData, index) {
            const base64 = await fetch(imgData);
            const blob = await base64.blob();
            let file_data = this.blobToFileClipboard(blob, 'clipboard_copied_image' + (new Date().getHours()  + '' + new Date().getMinutes()  + '' + new Date().getSeconds()) +'.png');
            // file_data  // file format type data of image
            // this.uploadDefaultFieldAttachment(file_data, index)
            let contains_duplicates = false
            this.template_details[index].attachments.forEach((e) => {
                if(e.name == file_data.name){
                    contains_duplicates = true
                }
            })
            if(this.template_details[index].attachments.length < 10 && !contains_duplicates){
                if (file_data) {
                    const CancelToken = axios.CancelToken;
                    const source = CancelToken.source();
                    let attachment = {
                        name: file_data.name,
                        size: JSON.stringify(file_data.size),
                        source: source,
                        progress: 0,
                        created_time: new Date(),
                        error: ""
                    }
                    this.template_details[index].attachments.push(attachment)
                    this.getResumable(file_data, this.template_details[index].attachments[this.template_details[index].attachments.length - 1]);
                }
            } else if(contains_duplicates){
                this.$toasted.global.error("This file is already uploaded")
            } else {
                this.$toasted.global.error("you're not allowed to upload more than 10 Attachments")
            }
        },
        async cropSuccessDefaultAttachment(imgData) {
            const base64 = await fetch(imgData);
            const blob = await base64.blob();
            let file_data = this.blobToFileClipboard(blob, 'clipboard_copied_image' + (new Date().getHours()  + '' + new Date().getMinutes()  + '' + new Date().getSeconds()) +'.png');
            let contains_duplicates = false
            this.attachments.forEach((e) => {
                if(e.name == file_data.name){
                    contains_duplicates = true
                }
            })
            if(this.attachments.length < 10 && !contains_duplicates){
                if (file_data) {
                    const CancelToken = axios.CancelToken;
                    const source = CancelToken.source();
                    let attachment = {
                        name: file_data.name,
                        size: JSON.stringify(file_data.size),
                        source: source,
                        progress: 0,
                        created_time: new Date(),
                        error: ""
                    }
                    this.attachments.push(attachment)
                    this.getResumable(file_data, this.attachments[this.attachments.length - 1]);
                }
            } else if(contains_duplicates){
                this.$toasted.global.error("This file is already uploaded")
            } else {
                this.$toasted.global.error("you're not allowed to upload more than 10 Attachments")
            }
        },
        uploadAttachmentByPart(event, index){
            console.log(event)
            console.log(index)
            try{
                console.log('uploadAttachmentByPart')
                if(event) {
                    var input = event.file;
                }
                if (input) {
                    let contains_duplicates = false
                    this.template_details[index].attach_files.forEach((e) => {
                        if(e.name == input.name){
                            contains_duplicates = true
                        }
                    })
                    if(this.template_details[index].attach_files.length < 10 && !contains_duplicates){
                        const CancelToken = axios.CancelToken;
                        const source = CancelToken.source();
                        let attachment = {
                            name: input.name,
                            size: JSON.stringify(input.size),
                            source: source,
                            progress: 0,
                            created_time: new Date(),
                            error: ""
                        }
                        this.template_details[index].attach_files.push(attachment)
                        this.getResumable(input, this.template_details[index].attach_files[this.template_details[index].attach_files.length - 1]);
                    } else if(contains_duplicates){
                        this.$toasted.global.error("This file is already uploaded")
                    } else {
                        this.$toasted.global.error("you're not allowed to upload more than 10 Attachments")
                    }
                }
            } catch(err){
                console.log(err)
            }
        },
        uploadAttachmentFromCameraByPart(file_data, index){
            let contains_duplicates = false
            this.template_details[index].attach_files.forEach((e) => {
                if(e.name == file_data.name){
                    contains_duplicates = true
                }
            })
            if(this.template_details[index].attach_files.length < 10 && !contains_duplicates){
                if (file_data) {
                    const CancelToken = axios.CancelToken;
                    const source = CancelToken.source();
                    let attachment = {
                        name: file_data.name,
                        size: JSON.stringify(file_data.size),
                        source: source,
                        progress: 0,
                        created_time: new Date(),
                        error: ""
                    }
                    this.template_details[index].attach_files.push(attachment)
                    this.getResumable(file_data, this.template_details[index].attach_files[this.template_details[index].attach_files.length - 1]);
                }
            } else if(contains_duplicates){
                this.$toasted.global.error("This file is already uploaded")
            } else {
                this.$toasted.global.error("you're not allowed to upload more than 10 Attachments")
            }
        }
    },
    computed:{
        error(){
            return ""
        }
    },
})